// Typed Hono RPC client for apps/api, built from that app's own route types
// (see apps/api/src/core/app.ts's `AppType`), so a call like
// `api.example.$get()` is checked against the real request/response shapes
// at build time instead of being hand-typed and left to drift.
//
// The `AppType` import below is `import type` only, so Bun's transpiler
// elides it entirely from the bundle: apps/api's runtime code (Postgres,
// Redis, S3, OpenAI clients) never ships to the browser, only the type
// information tsc needs is pulled in, and only at typecheck time.
import { hc } from "hono/client";
import type { AppType } from "@dashboard-intelligent/api/src/core/app";

// The API origin is fixed at build time: apps/web/build.ts replaces
// process.env.PUBLIC_API_URL through Bun.build `define`, so
// `PUBLIC_API_URL=https://api.example bun run build` points the bundle at a
// deployed API. Unset, it is apps/api's local port. apps/web/server.ts reads
// API_URL for its CSP connect-src; set both to the same origin.
export const apiUrl = process.env.PUBLIC_API_URL ?? "http://localhost:3001";

export const api = hc<AppType>(apiUrl);
